const STORAGE_KEY = "InfuseoneSelectedDoctorId"

export const getStoredSelectedDoctorId = () => {
  return localStorage.getItem(STORAGE_KEY) || ""
}

export const setStoredSelectedDoctorId = doctorId => {
  if (!doctorId) {
    localStorage.removeItem(STORAGE_KEY)
    return
  }

  localStorage.setItem(STORAGE_KEY, String(doctorId))
}

export const clearStoredSelectedDoctorId = () => {
  localStorage.removeItem(STORAGE_KEY)
}

export const getStoredUserInfo = () => {
  try {
    return JSON.parse(localStorage.getItem("Infuseoneuserinfo") || "{}")
  } catch (error) {
    return {}
  }
}

export const isGroupLoginUser = () => {
  const userInfo = getStoredUserInfo()
  return userInfo.is_group_login === true || userInfo.is_group_login === 1
}
